// @ts-nocheck TODO: fix types for the entire file

import styled, { StyledComponent } from '@emotion/styled';
import { MenuItem as MuiMenuItem, MenuItemProps } from '@mui/material';
import Tooltip from '@mui/material/Tooltip';
import { Box } from '@mui/system';
import { IconButton, Button } from 'components/Buttons';
import { CustomIcon } from 'components/CustomIcon';
import TypographyComponent from 'components/Typography/Typography';
import { theme } from 'theme';
import hexToRGBA from 'theme/hexToRGBA';
import pxToEm from 'theme/pxToEm';
import { ProjectDropdownVariant } from './ProductCard.types';

interface MenuButtonProps {
  isMenuOpen?: boolean;
}

export const MenuButton = styled(IconButton, {
  shouldForwardProp: (prop) => !['isMenuOpen'].includes(String(prop)),
})<MenuButtonProps>`
  position: absolute;
  right: ${pxToEm(16)};
  top: ${pxToEm(16)};
  z-index: 2;
  opacity: ${(props: { isMenuOpen: boolean }) =>
    props.isMenuOpen ? '1' : '0'};
  & > span {
    pointer-events: none;
    font-size: 1.5em !important;
  }
  &:hover,
  &:active,
  &:focus {
    background-color: ${({ theme }: { theme: any }) => theme.palette.grey[200]};
    color: ${({ theme }: { theme: any }) => theme.palette.primary.main};
  }
`;

interface InfoWrapperProps {
  contained?: boolean;
  shouldHideInfo?: boolean;
  isPriceLabel?: boolean;
  addedToCart?: boolean;
}

interface SelectedIconContainerProps {
  showAdvancedInfo?: boolean;
}

interface RelativeContainerProps {
  disabled?: boolean;
}

interface ContainerProps {
  bagActive?: boolean;
  contained?: boolean;
  isAddToCartLoading?: boolean;
  showSelect?: boolean;
  disabled: boolean;
}
interface StyledProps {
  showInfo?: boolean;
  isMasonry?: boolean;
  imageUrl?: string;
  showSelect?: boolean;
  isSelected?: boolean;
  isMenuOpen?: boolean;
  wasOrdered?: boolean;
  addedToFavorites?: boolean;
  isUploading?: boolean;
  disabled?: boolean;
  isContained?: boolean;
  contained?: boolean;
}

interface ButtonProps {
  added?: boolean;
}

interface IconContainerProps {
  top: number;
  right: number;
  isMobile?: boolean;
}

interface DropdownButtonProps {
  isAddedToCart?: boolean;
}

interface ProductInfoContainerProps {
  top?: boolean;
  isHover?: boolean;
  showContainedInfo?: boolean;
  activeScroll?: boolean;
}

interface ContainedCartButtonProps {
  shouldShow: boolean;
  isAddedToCart?: boolean;
}

interface CheckoutMenuContainerProps {
  isContained: boolean;
  showExtraInfo?: boolean;
  variant: ProjectDropdownVariant;
  maxWidth?: number;
}

interface ProjectDropdownContainer {
  variant: ProjectDropdownVariant;
  isContained?: boolean;
}

interface ProjectsSearchScrollContainerProps {
  showProjectsSearch?: boolean;
}

interface ActionButtonProps {
  hidden?: boolean;
}

interface DropdownOnlyProps {
  isDropdownOnly?: boolean;
}

export const CoverContainer = styled.div<{
  isHover?: boolean;
  isOutlined?: boolean;
  isMobile?: boolean;
}>`
  position: relative;
  width: 100%;
  height: 100%;
  box-shadow: ${({ isOutlined, theme }) =>
    isOutlined ? `0 0 0 2px ${theme.palette.primary.main}` : 'none'};
  padding: ${({ isOutlined }) => (isOutlined ? '2px' : '0')};
  border-radius: 20px;

  ${MenuButton} {
    opacity: ${({ isHover, isMobile }) => (isHover || isMobile ? 1 : 0)};
    top: 16px;
    width: 34px;
    height: 34px;
  }
`;

export const ProductInfoContainer = styled.div<ProductInfoContainerProps>`
  width: ${({ isHover, activeScroll }) =>
    isHover && activeScroll ? '86%' : 'calc(100% - 1.5em)'};
  max-width: ${({ isHover, activeScroll }) =>
    isHover && activeScroll ? '86%' : 'calc(100% - 1.5em)'};
  ${(props) => (props.top ? `top: ${pxToEm(12)}` : '')};
  bottom: ${({ isHover, showContainedInfo }) =>
    isHover && !showContainedInfo ? pxToEm(64) : pxToEm(12)};
  left: ${pxToEm(12)};
  position: absolute;
  z-index: 2;
  display: flex;
  flex-direction: column;
  max-height: calc(100% - 60px);
  overflow-y: auto;
  pointer-events: ${({ top }) => (top ? 'none' : 'all')};
  pointer-events: ${({ activeScroll }) => (activeScroll ? 'all' : 'none')};
  &::-webkit-scrollbar {
    width: 6px;
  }
  &::-webkit-scrollbar-track {
    background: ${hexToRGBA(theme.palette.grey[400], 0.6)};
  }
  &::-webkit-scrollbar-thumb {
    opacity: 0.4;
    background: ${hexToRGBA(theme.palette.grey[600], 0.6)};
    border-radius: 4px;
    border: 3px none ${theme.palette.common.white};
  }
  cursor: pointer;
`;

export const ProductInfoText = styled(TypographyComponent)<{
  isTopLabel?: boolean;
}>`
  color: ${theme.palette.common.white};
  ${({ isTopLabel }) =>
    isTopLabel &&
    `
  display: flex;
  flex-wrap: wrap;
  gap: 2px;
  svg {
    position: relative;
    top: -1px;
    right: -2px;
  }
  `}
`;

export const FeatureItem = styled('div', {
  shouldForwardProp: (prop) =>
    prop !== 'isTopLabel' && prop !== 'bgColor' && prop !== 'textColor',
})<{
  bgColor?: string;
  textColor?: string;
  isTopLabel?: boolean;
}>`
  display: flex;
  white-space: nowrap;
  align-items: center;
  width: fit-content;
  margin: ${pxToEm(4)};
  font-weight: 400;
  border-radius: ${pxToEm(24)};
  background-color: ${({ theme, bgColor, isTopLabel }) =>
    bgColor ||
    (isTopLabel
      ? theme.palette.lime.main
      : hexToRGBA(theme.palette.common.black, 0.4))};
  color: ${({ theme, textColor, isTopLabel }) =>
    textColor ||
    (isTopLabel ? theme.palette.primary.main : theme.palette.common.white)};
  font-size: ${pxToEm(11)};
  padding: 0 8px;
  max-width: 100%;
  svg > path {
    stroke: ${({ theme, textColor, isTopLabel }) =>
      textColor ||
      (isTopLabel ? theme.palette.primary.main : theme.palette.common.white)};
  }
  small {
    font-size: inherit;
    display: block;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  span + p {
    max-width: calc(100% - 1.5em);
  }
  p {
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    margin: 0;
    padding: 0;
  }
`;

export const Content = styled.div`
  flex: 1;
  justify-content: space-between;
  align-items: flex-end;
  display: flex;
  width: 100%;
`;

export const TopRightButtonsWrapper = styled.div<IconContainerProps>`
  position: absolute;
  top: ${(props) => pxToEm(props.top)};
  right: ${(props) => pxToEm(props.right)};
  z-index: 2;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  & > * {
    margin-left: 0.5em !important;
  }
  ${({ isMobile, theme }) =>
    isMobile
      ? `
    & svg {
      color: ${theme.palette.common.white}
    }
  `
      : ''}
`;

export const AddToButton = styled(IconButton, {
  shouldForwardProp: (prop) => String(prop) !== 'added',
})<ButtonProps>`
  width: ${pxToEm(34)};
  height: ${pxToEm(34)};
  svg {
    path {
      stroke-width: 1px;
      fill: ${(props) =>
        props.added ? props.theme.palette.primary.main : 'transparent'};
    }
  }
  .MuiCircularProgress-root {
    width: 100% !important;
    height: 100% !important;
  }
`;

export const AddToBagWrapper = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 2;
`;

export const InfoWrapper = styled.div<InfoWrapperProps>`
  padding: ${pxToEm(12)} ${pxToEm(10)} ${pxToEm(10)};
  border-radius: 200px;
  flex-grow: ${(props) => (props.contained ? '0' : '1')};
  position: ${(props) => (props.contained ? 'absolute' : 'relative')};
  bottom: ${(props) => (props.contained ? 0 : 'unset')};
  left: ${(props) => (props.contained ? 0 : 'unset')};
  right: ${(props) => (props.contained ? 0 : 'unset')};
  z-index: 1;
  pointer-events: ${(props) => (props.contained ? 'none' : 'auto')};
  display: flex;
  justify-content: space-between;
  ${theme.breakpoints.up('md')} {
    padding: ${pxToEm(20)};
  }
`;

export const SelectedIconContainer = styled.div<SelectedIconContainerProps>`
  position: absolute;
  top: ${pxToEm(16)};
  left: ${pxToEm(16)};
  display: block;
  z-index: 3;

  & > span {
    border: 2px solid ${theme.palette.common.white};
    opacity: 1 !important;
    &[aria-disabled='true'] {
      opacity: 0.5 !important;
    }
  }
`;

export const DimmedBackground = styled.div<StyledProps>`
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1;
  background: ${({ theme, contained }) =>
    contained ? 'none' : theme.hexToRGBA(theme.palette.common.black, 0.3)};
  box-shadow: ${({ contained }) =>
    !contained ? 'none' : 'inset 0 -150px 150px -120px #000000'};
  pointer-events: none;
  border-radius: ${pxToEm(20)};
`;

export const MenuContainer = styled.div`
  display: block;
  pointer-events: auto;
`;

export const Container = styled.div<ContainerProps>`
  width: 100%;
  position: relative;
  //overflow: hidden;
  background-color: ${theme.palette.common.white};
  border-radius: ${pxToEm(20)};
  flex-direction: column;
  display: flex;
  ${({ disabled }) =>
    disabled
      ? `
        filter: grayscale(1);
        opacity: 0.4;
      `
      : ''}
`;

export const MenuItem: StyledComponent<MenuItemProps> = styled(MuiMenuItem)`
  min-width: ${pxToEm(162)};
`;

export const MoreInfoButton = styled(IconButton)`
  width: ${pxToEm(40)};
  height: ${pxToEm(40)};
  background: ${theme.palette.common.white};
  &:hover,
  &:focus,
  &:active {
    background: ${theme.palette.common.white};
  }
  box-shadow: 0 0 ${pxToEm(5)} 0 ${hexToRGBA(theme.palette.common.black, 0.3)};
  svg {
    color: ${theme.palette.common.black};
  }
`;

export const InfoLabel = styled(TypographyComponent, {
  shouldForwardProp: (prop) =>
    !['isPriceLabel', 'contained'].includes(String(prop)),
})<InfoWrapperProps>`
  color: ${(props) =>
    props.contained ? props.theme.palette.common.white : 'initial'};
  font-size: ${pxToEm(14)};
  line-height: 1.5;
  white-space: nowrap;
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const TopWrapper = styled.div`
  display: flex;
`;

export const DropdownButton = styled(IconButton, {
  shouldForwardProp: (prop) => !['isAddedToCart'].includes(String(prop)),
})<DropdownButtonProps>`
  height: ${pxToEm(38)};
  width: ${pxToEm(38)};
  svg {
    font-size: ${pxToEm(16)};
  }
  ${(props) => props.isAddedToCart && 'pointer-events: none;'}

  svg > path {
    ${({ isAddedToCart }) =>
      isAddedToCart && `stroke: ${theme.palette.common.white};`}
  }
  &:hover,
  &:focus,
  &:active {
    background: ${theme.palette.primary.main} !important;
    color: ${theme.palette.common.white};
  }

  ${theme.breakpoints.down('md')} {
    &:hover,
    &:focus,
    &:active {
      background: ${theme.palette?.secondary?.main} !important;
      color: ${theme.palette.primary.main};
    }
  }
`;

export const ContainedCartButton = styled(IconButton, {
  shouldForwardProp: (prop) =>
    !['shouldShow', 'isAddedToCart'].includes(String(prop)),
})<ContainedCartButtonProps>`
  position: absolute;
  right: ${pxToEm(16)};
  bottom: ${pxToEm(16)};
  z-index: 2;
  opacity: ${(props) => (props.shouldShow ? 1 : 0)};
  ${(props) => props.isAddedToCart && 'pointer-events: none;'}
`;

export const ProjectDropdownContainer = styled.div<ProjectDropdownContainer>`
  position: absolute;
  bottom: ${({ isContained }) => (isContained ? pxToEm(12) : '2px')};
  left: ${({ isContained }) => (isContained ? pxToEm(12) : 0)};
  width: ${({ isContained }) =>
    isContained ? `calc(100% - ${pxToEm(24)})` : '100%'};
  z-index: 3;
  background-color: ${({ theme, variant }) =>
    variant === ProjectDropdownVariant.CONTAINED
      ? theme.palette.secondary?.main
      : 'unset'};
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: ${pxToEm(4)} ${pxToEm(4)} ${pxToEm(4)} ${pxToEm(18)};
  cursor: pointer;
`;

export const CheckoutMenuContainer = styled.div<CheckoutMenuContainerProps>`
  z-index: 8;
  position: absolute;
  top: ${({ isContained }) => (isContained ? 0 : `calc(100% - ${pxToEm(48)})`)};
  left: 0;
  background-color: ${theme.palette.common.white};
  width: 100%;
  border-radius: 20px;
  box-shadow: ${`0px 4px 25px ${hexToRGBA(theme.palette.common.black, 0.08)}`};
  overflow: hidden;
  max-width: ${({ maxWidth }) =>
    maxWidth != null ? pxToEm(maxWidth) : 'none'};
  padding: ${pxToEm(8)};
`;

export const ProjectsSearchContainer = styled.div`
  display: flex;
  align-items: center;
  background-color: ${theme.palette.secondary?.main};
  width: 100%;
  border-radius: 24px;
  padding: ${pxToEm(8)} ${pxToEm(16)};

  svg {
    color: ${theme.palette.grey['A400']};
  }
`;

export const ProjectsSearchInput = styled.input`
  border: none;
  outline: 0;
  width: 90%;
  background: transparent;
  font-size: ${pxToEm(13)};
`;

export const CheckoutDivider = styled.hr`
  border: 0.5px solid ${theme.palette.grey[50]};
  margin: 0;
`;

export const ProjectsSearchScrollContainer = styled.div<ProjectsSearchScrollContainerProps>`
  overflow: scroll;
  max-height: ${pxToEm(150)};
  ${({ showProjectsSearch }) =>
    showProjectsSearch && `padding-top: ${pxToEm(8)};`}
  padding-bottom: ${pxToEm(8)};
  -ms-overflow-style: none;
  scrollbar-width: none;

  &::-webkit-scrollbar {
    display: none;
  }
  p {
    cursor: pointer;
  }
`;

export const ProductInfoWrapper = styled(Box)`
  padding: 0.25em 0.25em 0.5em;
  min-height: 120px;
`;
export const RelativeContainer = styled.div<RelativeContainerProps>`
  position: relative;
  ${({ disabled }) => disabled && 'pointer-events: none;'}
`;

export const StaticProjectDropdownContainer = styled.div`
  width: 100%;

  & > div:first-of-type {
    position: relative;
    height: 32px;
    padding: ${pxToEm(4)};

    & > div:first-of-type {
      justify-content: center;

      & > p {
        font-size: ${pxToEm(13)};
        line-height: ${pxToEm(20)};
      }
    }
  }
`;

export const DropDownWrapper = styled(Box, {
  shouldForwardProp: (prop) => String(prop) !== 'withBag',
})<{ withBag?: boolean }>`
  display: flex;
  align-items: center;
  width: calc(100% - ${({ withBag }) => (!withBag ? '0px' : pxToEm(38))});
`;

export const SelectedProjectLabel = styled(TypographyComponent, {
  shouldForwardProp: (prop) => String(prop) !== 'dropdownVariant',
})<{ dropdownVariant: ProjectDropdownVariant; minWidth?: number }>`
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  min-width: ${({ minWidth }) => minWidth || 0}px;
  font-size: ${({ dropdownVariant }) =>
    pxToEm(dropdownVariant === ProjectDropdownVariant.CONTAINED ? 13 : 16)};
  line-height: ${({ dropdownVariant }) =>
    dropdownVariant === ProjectDropdownVariant.CONTAINED ? '20px' : '38px'};
`;

export const SelectedProjectPreLabel = styled(TypographyComponent, {
  shouldForwardProp: (prop) => String(prop) !== 'dropdownVariant',
})<{ dropdownVariant: ProjectDropdownVariant }>`
  font-size: ${({ dropdownVariant }) =>
    pxToEm(dropdownVariant === ProjectDropdownVariant.CONTAINED ? 13 : 16)};

  line-height: ${({ dropdownVariant }) =>
    dropdownVariant === ProjectDropdownVariant.CONTAINED ? '20px' : '38px'};
  padding-right: ${pxToEm(5)};
  color: ${theme.palette.grey['A400']};
`;

export const DropdownProjectLine = styled.div<DropdownOnlyProps>`
  width: 100%;
  border-radius: ${pxToEm(8)};
  padding: 0 ${pxToEm(12)};
  height: ${pxToEm(36)};
  display: flex;
  align-items: center;
  justfify-content: space-between;
  white-space: nowrap;
  overflow: hidden;
  &:hover {
    background: ${theme.palette.secondary?.main};
  }
  p {
    ${(props) => (props.isDropdownOnly ? 'font-size: 16px;' : '')}
    width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
`;

export const CreateProjectButton = styled(Button)<DropdownOnlyProps>`
  padding: ${pxToEm(14)} 0 ${pxToEm(6)} 0;
  font-size: ${(props) => (props.isDropdownOnly ? 16 : 13)}px;
`;

export const ActionButtonContainer = styled.div`
  margin-top: ${pxToEm(4)};
  padding-left: ${pxToEm(4)};
  padding-right: ${pxToEm(4)};
`;

export const ActionButton = styled(Button)<ActionButtonProps>`
  height: 36px;
  padding: 6px 8px !important;
  ${({ hidden }) => hidden && 'visibility: hidden;'}
  .buttonLabel {
    max-width: 100%;
    text-align: center;
    overflow: hidden;
    text-overflow: ellipsis;
  }
`;

export const SubtextIcon = styled(CustomIcon)`
  rect {
    fill: ${theme.palette.info.main};
  }
`;

export const ContactRepButton = styled(Button)`
  margin-top: ${pxToEm(4)};
  padding: ${pxToEm(4)} ${pxToEm(8)};
  pointer-events: all;
`;

export const VariantIcon = styled.div<{ isActive?: boolean }>`
  width: 24px;
  height: 24px;
  border-radius: 4px;
  display: flex;
  background-color: ${theme.palette.secondary.main};
  cursor: pointer;
  filter: brightness(0.95);
  &:hover {
    filter: brightness(0.85);
  }
  ${({ isActive }) =>
    isActive &&
    `
    border: 1px solid ${theme.palette.primary.main};
    box-shadow: inset 0 0 0 1px #fff;
  `}
  img {
    width: 24px;
    height: 24px;
    object-fit: cover;
    border-radius: 4px;
  }
`;

export const VariantLeft = styled(TypographyComponent)`
  height: 24px;
  padding: 0 6px;
  font-size: 10.5px;
  line-height: 24px;
  cursor: pointer;
`;

export const VariantContainer = styled(Box, {
  shouldForwardProp: (prop) => String(prop) !== 'isSelectActive',
})<{ isSelectActive?: boolean }>`
  ${({ isSelectActive }) =>
    isSelectActive &&
    `
    opacity: 0.5;
    pointer-events: none;
  `}
`;

export const TooltipInfo = styled(Tooltip)`
  & ~ .MuiTooltip-popper {
    z-index: 5 !important;
    .MuiTooltip-tooltip {
      margin-top: 4px !important;
      background: ${theme.palette.primary.main};
      color: ${theme.palette.common.white};
      font-size: 10px;
      padding: 7px 12px;
      border-radius: 24px;
      text-align: center;
      min-height: 12px;
    }
  }
`;

export const TooltipCursor = styled(Tooltip)`
  & ~ .MuiTooltip-popper {
    .MuiTooltip-tooltip {
      margin-top: 20px !important;
      background: rgba(77, 78, 88, 0.75);
      color: ${theme.palette.common.white};
      font-size: 12px;
      padding: 7px 12px;
      border-radius: 24px;
      text-align: center;
      min-height: 24px;
    }
  }
`;

export const CheckboxTooltip = styled(Tooltip)`
  & ~ .MuiTooltip-popper {
    .MuiTooltip-tooltip {
      margin-top: 20px !important;
      background: ${theme.palette.primary.main};
      color: ${theme.palette.common.white};
      font-size: 12px;
      padding: 7px 12px;
      border-radius: 24px;
      text-align: center;
      min-height: 24px;
    }
  }
`;
